import { Component } from 'react'
import { withTranslation } from '~/i18n'
import OrderListLongPolling from '~/utils/OrderListLongPolling'
import Icon from '~/utils/Icon'
import styles from '~/styles/getLabelButton.module.css'

class GetLabelButton extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders' ],
		}
	}
	
	constructor(props) {
		super(props)
		this.mainOrderName = "order"
		this.multipackagePrefix = "pkg"
		this.generateStatuses = [ 'NEW', 'HOLD' ]
		this.formats = [ 'PDF', 'PNG', 'ZPL' ]
		let format = this.props.order.labelFormat
		if (!format) {
			format = this.props.order.dealerAndChildDealers?.[this.props.order.dealerId].label_format
		}
		this.state = {
			isFormatsShown: !!this.props.isFormatsShown,
			currentFormat: format,
		}
		this._longPolling = new OrderListLongPolling()
	}

	render() {
		if (this.props.show) {
			let className = styles.main
			if (this.props.isAtBottom) {
				className += ' ' + styles.isAtBottom
			}
			if (this.props.isDisabled) {
				className += ' ' + styles.disabled
			}
			return (
				<>
					<div
						className={className}
					>
						<div>
							<Icon
								iconName="sticker"
							/>
						</div>
						{this._getPrintButton()}
						{this._getSureSign()}
					</div>
					{this._getLoadingDots()}
				</>
			)
		} else {
			return null
		}
	}

	_getSureSign() {
		if (!this.props.processOrder) {
			return (
				<div
					className={styles.sureFrame}
				>
					{this._getSure()}
					{this._getError()}
				</div>
			)
		} else {
			if (this.state.isSureShown) {
				return (
					<div
						className={styles.sureFrame}
					>
						 {this._getSure()}
					</div>
				)
			} else if (this.state.resultError) {
				return (
					<>
						{this._getError()}
					</>
				)
			}
		}
	}

	_getLoadingDots() {
		if (this.state.isFetching && this.props.processOrder) {
			return (
				<div
					className={styles.onLoading}
				>
					<div>
						<Icon name="nineDots" />
						<Icon name="nineDots" />
						<Icon name="nineDots" />
						<Icon name="nineDots" />
					</div>
				</div>
			)
		} else {
			return null
		}
	}

	_getPrintButton() {
		let buttonSign = this.props.t('Generate label')
		let awaitingSign = this.props.t('Generating')
		if (!this.generateStatuses.includes(this.props.order.status) && this.props.order.status) {
			buttonSign = this.props.t('Print label')
			awaitingSign = this.props.t('Printing')
		}
		awaitingSign += ` ${this.state.currentFormat} ...`
		if (!this.state.isFetching) {
			return (
				<div
					className={styles.printButtonFrame}
				>
					<div
						className={styles.printButton}
						onClick={this._onPrintButton.bind(this)}
					>
						{buttonSign}
					</div>
					{this._getMultiPackages()}
					{this._getFormats()}
				</div>
			)
		} else {
			return (
				<div>
					{awaitingSign}
				</div>
			)
		}
	}

	_getFormats() {
		let format = this.state.currentFormat
		if (!format) {
			format = this.props.order.dealerAndChildDealers?.[this.props.order.dealerId].label_format
		}
		return (
			<>
				<div
					className={styles.interspace}
				>
					as
				</div>
				<div
					className={styles.formats}
				>
					<select
						value={format}
						onChange={this._onFormat.bind(this)}
					>
						<option
							value={format}
						>
							{format}
						</option>
						{this._getOtherFormats()}
					</select>
				</div>
			</>
		)
	}

	_getOtherFormats() {
		const jsx = []
		this.formats.forEach(format => {
			if (format !== this.state.currentFormat) {
				jsx.push((
					<option
						value={format}
					>
						{format}
					</option>
				))
			}
		})
		return jsx
	}

	_getMultiPackages() {
		if (this.props.order.multiPackages?.package_nums?.length) {
			return (
				<>
					<div
						className={styles.interspace}
					>
						of
					</div>
					<select
						value={this.state.currentMultiPackageName}
						onChange={this._onMultiPackageOptions.bind(this)}
					>
						{this._getMultiPackageOptions()}
					</select>
				</>
			)
		} else {
			return null
		}
	}

	_getMultiPackageOptions() {
		const jsx = []
		this.props.order.multiPackages?.package_nums.forEach(name => {
			jsx.push(this._getMultiPackageOption(name))
		})
		return jsx		
	}

	_getMultiPackageOption(name) {
		let text = name
		if (name !== this.mainOrderName) {
			text = this.multipackagePrefix + " " + name
		}
		return (
			<option
				value={name}
			>
				{text}
			</option>
		)
	}

	_getError() {
		if (this.state.resultError) {
			return (
				<div
					className={styles.error}
				>
					<div>
						{this.props.t('Error')}:
					</div>
					<div>
						{this.state.resultError}
					</div>
				</div>
			)
		} else {
			return null
		}
	}

	_getSure() {
		if (this.state.isSureShown) {
			return (
				<>
					<div
						className={styles.sureLine}
					>
						<div>
							{this.props.t('Are you sure to generate label?')}
						</div>
					</div>
					<div
						className={styles.sureAnswersLine + (this.props.processOrder ? ' ' + styles.noMarginBottom : '')}
					>
						<div
							onClick={this._onCancel.bind(this)}
						>
							{this.props.t('Cancel')}
						</div>
						<div
							className={styles.isDefault}
							onClick={this._onSure.bind(this)}
						>
							{this.props.t('Yes')}
						</div>
					</div>
				</>
			)
		} else {
			return null
		}
	}

	_onPrintButton() {
		if (!this.state.isFetching && !this.props.isDisabled) {
			if (this.props.order.status === 'HOLD' || this.props.processOrder) {
				this.setState({ isSureShown: true })
				if (!this.props.isAtBottom) {
					this._scroll()
				}
			} else {
				setTimeout(() => {
					this._onSure()
				})
			}
		}
	}

	_onFormat(event) {
		this.setState({ currentFormat: event.target.value })
	}

	_onMultiPackageOptions(event) {
		let value = event.target.value
		if (value === this.mainOrderName) {
			value = null
		}
		this.setState({ currentMultiPackageName: value })	
	}

	async _onSure() {
		if (!this.state.isFetching) {
			this.setState({
				isSureShown: false,
				isFetching: true,
				resultError: null,
			})
			setTimeout(() => {
				if (this.state.isFetching) {
					this.setState({
						isFetching: false,
						showExtraFormats: false,
						resultError: 'Timeout',
					})
				}
			}, 60 * 1000)
			if (this.props.processOrder) {
				const ok = await this.props.processOrder()
				if (!ok) {
					this.setState({
						isFetching: false,
						format: null,
						showExtraFormats: false,
						resultError: `Order can't be processed`
					})
					return
				}
				let isStatusAwaitingRequried = true
				if (this.props.order.onEdit && this.props.order.fulfillmentStatus === 'HOLD') {
					isStatusAwaitingRequried = false
				}
				if (isStatusAwaitingRequried) {
					const status = await this._longPolling.awaitApprovedLikeStatus(this.props.order.dealerId, this.props.order.orderNumber)
					if (!status) {
						this.setState({
							isFetching: false,
							format: null,
							showExtraFormats: false,
						})
						return
					}
				}
			}
			this._labelRequest()
		}
	}

	_labelRequest() {
		const postObject = {
			orderDealerId: this.props.order.in_shop_id,
			orderDealerToken: this.props.order.dealer_token,
			orderNumber: this.props.order.ext_key,
			labelFormat: this.state.currentFormat,
			stage: this.props.stage,
		}
		if (this.state.currentMultiPackageName) {
			postObject.pieceNumber = this.state.currentMultiPackageName - 1
		}
		if (this.props.processOrder) {
			postObject.orderDealerId = this.props.order.dealerId
			postObject.orderDealerToken = this.props.order.dealerAndChildDealers[this.props.order.dealerId]?.dealer_token
			postObject.orderNumber = this.props.order.orderNumber
		}
		fetch('/api/v1/getLabel', {
			headers: { 'Content-Type': 'application/json' },
			method: 'POST',
			body: JSON.stringify(postObject),
		}).then(async response => {
			if (response.status === 200) {
				return response.text()
			} else {
				return response.json()
			}
		}).then(data => {
			if (typeof data === 'string') {
				this.setState({
					resultError: null,
				})
				setTimeout(() => {
					this.setState({ format: null })
				}, 2000)
				const link = document.createElement('a')
				link.download = 'label'
				link.href = data
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			} else {
				if (data?.error) {
					this.setState({
						resultError: data.error,
					})
				}
			}
		}).finally(() => {
			this.setState({
				isFetching: false,
				format: null,
				showExtraFormats: false,
			})
		})
	}

	_onCancel() {
		this.setState({
			format: null,
			isSureShown: false,
		})
		if (!this.props.processOrder) {
			this.setState({
				isFormatsShown: false
			})
		}
	}

	_scroll() {
		setTimeout(() => {
			let isSureSignNotVisible = false
			const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
			const rect = document.querySelector('div[class*="getLabelButton_sureLine"]').getBoundingClientRect()
			if (rect.bottom > vh) {
				isSureSignNotVisible = true
			}
			if (isSureSignNotVisible) {
				const rect = document.querySelector('div[class*="getLabelButton_sureAnswersLine"]').getBoundingClientRect()
				const orderDetails = document.querySelector('div[class*="orderDetails_main"]')
				orderDetails.scrollBy({
				  top: (rect.bottom + rect.height) - vh,
				  behavior: 'smooth',
				})
			}
		})
	}
}

export default withTranslation(['Orders'])(GetLabelButton)